<main>

  <ng-container *ngIf="layoutVars || layoutVarsResponse">
  
    <div class="row content-header">
      <div class="col-md-8 mx-auto">
        <a [href]="env">
          <img
            [src]="layoutVars && layoutVars.logoUrl ? layoutVars.logoUrl : './assets/images/logo/logo-arremaq-superbid.png'"
            class="logo"
            height="48" />
        </a>
      </div>
    </div>
  
    <div class="row o-hidden screen-lg content-columns">
  
      <!-- Dealers -->
      <div class="col-6">
        <div class="card" [@animate]="{ value: '*', params: { y: '120px', opacity: '0', delay: '100ms', duration: '400ms' } }">
          <ng-container [ngTemplateOutlet]="forDealersForm"></ng-container>
        </div>
      </div>
  
      <!-- Buyers -->
      <div class="col-6">
        <div class="card" [@animate]="{ value: '*', params: { y: '120px', opacity: '0', delay: '100ms', duration: '400ms' } }">
          <ng-container [ngTemplateOutlet]="forBuyersForm"></ng-container>
        </div>
      </div>
  
    </div>
  
    <div class="row o-hidden screen-sm content-tabs">
      
      <div class="col-md-10 mx-auto">
        <div class="card" [@animate]="{ value: '*', params: { y: '120px', opacity: '0', delay: '100ms', duration: '400ms' } }">
          <div class="tabs-container container-fluid">
            <mat-tab-group dynamicHeight mat-align-tabs="center" mat-stretch-tabs [selectedIndex]="1">
      
              <!-- Dealers -->
              <mat-tab>
                <ng-template mat-tab-label>
                  <span class="text-uppercase">
                    Vendedores
                  </span>
                </ng-template>
                <div class="row mt-32">
                  <div class="col">
                    <ng-container
                      [ngTemplateOutlet]="forDealersForm"></ng-container>
                  </div>
                </div>
              </mat-tab>
      
              <!-- Buyers -->
              <mat-tab>
                <ng-template mat-tab-label>
                  <span class="text-uppercase">
                    Compradores
                  </span>
                </ng-template>
                <div class="mt-32">
                  <ng-container
                    [ngTemplateOutlet]="forBuyersForm"></ng-container>
                </div>
              </mat-tab>
      
            </mat-tab-group>
          </div>
        </div>
      </div>
  
    </div>
    
    <footer class="row content-footer">
      <div class="col">
        <app-footer></app-footer>
      </div>
    </footer>

  </ng-container>
  

</main>

<ng-template #forDealersForm>

  <div class="row">
    <div class="col">
    
      <div class="row">
        <div class="col-10 mx-auto">
    
          <div class="row">
            <div class="col">
              <h4 class="text-center text-uppercase">
                Para vendedores
              </h4>
              <p class="text-center">
                Anuncie seus ativos para compradores do Brasil inteiro e expanda seu número de parceiros.
              </p>
            </div>
          </div>
    
          <div class="mt-2 mb-5">
            <form [formGroup]="form" (validSubmit)="signin($event)">
              <!-- Error message -->
              <div class="row" *ngIf="showError">
                <div class="col">
                  <ngb-alert
                    class="alert-card container-fluid"
                    [type]="'danger'"
                    (close)="closeAlert()">
                    <ng-container *ngIf="statusUser === 'USER_NOT_FOUND'; else defaultErrorMessage">
                      <span>
                        Você ainda não possui conta!
                        Clique <a [routerLink]="['/create-dealer']" class="hover-underline">aqui</a> para criar a sua conta.
                      </span>
                    </ng-container>
                    <ng-template #defaultErrorMessage>
                      <span>
                        {{ messageError }}
                      </span>
                      <span *ngIf="cellPhone && statusUser === 'UNREGISTERED_USER'">
                        <br />
                        <ng-container *ngIf="sentSMS">
                          SMS enviado. Clique no link recebido no seu celular e finalize o cadastro.
                        </ng-container>
                        <ng-container *ngIf="!sentSMS">
                          Caso prefira receber o link de cadastro via SMS no telefone {{cellPhone}},
                          <span (click)="sendSMS()" class="cursor-pointer underline">clique aqui</span>.
                        </ng-container>
                      </span>
                    </ng-template>
                  </ngb-alert>
                </div>
              </div>
    
              <div class="row">
                <div class="col-md-12">
                  <mat-form-field>
                    <input matInput placeholder="E-MAIL" formControlName="email">
                  </mat-form-field>
                </div>
              </div>
    
              <div class="row" *ngIf="statusUser === 'REGISTERED_USER'">
                <div class="col-md-12">
                  <mat-form-field>
                    <input type="password" matInput placeholder="SENHA" formControlName="password" autofocus>
                  </mat-form-field>
                </div>
              </div>
    
              <div class="row mt-4">
                <div class="col-md-12">
                  <btn-loading
                    btnClass="btn-primary btn-lg btn-block btn-rounded"
                    [loadingText]="loadingText"
                    [loading]="loading$ | async">
                    ACESSAR
                  </btn-loading>
                </div>
              </div>
              
              <div class="row mt-4 block">
                <div class="col-md-12 text-center">
                  <a
                    class="link-forgot-password text-primary"
                    [routerLink]="['/forgot-password']"
                    [queryParams]="{ email: providedEmailAddress }">
                    Esqueceu a senha?
                  </a>
                </div>
              </div>
    
            </form>
          </div>
          
        </div>
      </div>
    
      <div class="register-container row mt-2 bg-gray-200 py-32">
        <div class="col">
          <div class="row">
            <div class="col-10 mx-auto">
              <div class="text-primary create-dealer-account-text">
                <p class="text-primary">
                  Gostaria de criar uma conta de vendedor?
                </p>
                <p class="text-gray">
                  <a [href]="blogUrl + '#contato'" target="_blank" class="underline text-gray">Preencha o formulário</a>
                  e comece agora.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

    </div>
  </div>

</ng-template>

<ng-template #forBuyersForm>

  <div class="row">
    <div class="col">

      <div class="row">
        <div class="col-10 mx-auto">
          <h4 class="text-center text-uppercase">
            Para compradores
          </h4>
          <p class="text-center">
            Tenha acesso à plataforma {{ layoutVars ? layoutVars.name : 'Arremaq' }} por meio uma conta Superbid Exchange.
            Acesse agora mesmo.
          </p>
        </div>
      </div>

      <div class="row">
        <div class="col-10 mx-auto">
          <div class="mt-2 mb-5 text-center">
            <button class="btn btn-superbid btn-lg mx-auto" (click)="redirectSuperbidAccounts()">
              <img src="./assets/images/logo_superbid_circle.svg" height="20" />
              <span>
                Acessar com SuperBid Exchange
              </span>
            </button>
          </div>
        </div>
      </div>

    </div>
  </div>
  
</ng-template>

